import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import { Eye, EyeOff, WandSparkles } from 'lucide-react';
import { easyPassword } from '@pulsepoint/shared';
import { useState } from 'react';
import type { FieldValues } from 'react-hook-form';
import { FormTextField, type FormTextFieldProps } from './FormTextField';

/**
 * A password field with a show/hide button. With `onGenerate`, a second button makes an
 * easy-to-remember password (e.g. "QuietHorse96#"), shows it, and hands it to the form.
 */
export function PasswordField<T extends FieldValues>({ onGenerate, ...props }: FormTextFieldProps<T> & { onGenerate?(password: string): void }) {
  const [shown, setShown] = useState(false);
  return (
    <FormTextField
      {...props}
      type={shown ? 'text' : 'password'}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              {onGenerate && (
                <Tooltip title="Make an easy-to-remember password">
                  <IconButton
                    onClick={() => {
                      onGenerate(easyPassword());
                      setShown(true);
                    }}
                    aria-label="Make an easy-to-remember password"
                    size="small"
                    sx={{ mr: 0.5 }}
                  >
                    <WandSparkles size={20} strokeWidth={1.5} />
                  </IconButton>
                </Tooltip>
              )}
              <IconButton onClick={() => setShown((s) => !s)} edge="end" aria-label={shown ? 'Hide password' : 'Show password'} size="small">
                {shown ? <EyeOff size={20} strokeWidth={1.5} /> : <Eye size={20} strokeWidth={1.5} />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
